<template>
  <!-- 教师成本 -->
  <div class="teacher-cost">
    <el-form class="select" label-width="120px">
      <el-form-item label="日期:">
        <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="教师姓名:">
        <el-input placeholder="请选择教师姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="超课时部分奖励:">
        <el-input placeholder="请输入超课时部分奖励" clearable></el-input>
      </el-form-item>
      <el-form-item label="超课时1v多奖励:">
        <el-input placeholder="请输入超课时1v多奖励" clearable></el-input>
      </el-form-item>
      <el-form-item label="日五节课奖励:">
        <el-input placeholder="请输入超课时1v多奖励" clearable></el-input>
      </el-form-item>
      <el-form-item label="学员总课时奖励:">
        <el-input placeholder="请输入学员总课时奖励" clearable></el-input>
      </el-form-item>
      <el-form-item label="内推奖励:">
        <el-input placeholder="请输入内推奖励" clearable></el-input>
      </el-form-item>
      <el-form-item label="总成本:">
        <el-input placeholder="请输入总成本" clearable></el-input>
      </el-form-item>
      <el-form-item label="课时费:">
        <el-input placeholder="请输入课时费" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">清除</el-button>
        <el-button type="primary">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="goChart">成本统计图</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="dataList" border>
      <el-table-column width="120" prop="" label="日期">
      </el-table-column>
      <el-table-column width="120" prop="" label="教师姓名">
      </el-table-column>
      <el-table-column prop="" label="总成本">
      </el-table-column>
      <el-table-column width="130" prop="" label="课时费">
      </el-table-column>
      <el-table-column width="110" prop="" label="超课时部分奖励">
      </el-table-column>
      <el-table-column label="超课时1v多奖励">
      </el-table-column>
      <el-table-column prop="" width="120" label="日五节课奖励">
      </el-table-column>
      <el-table-column width="120" prop="" label="学员总课时奖励">
      </el-table-column>
      <el-table-column width="150" prop="" label="内推奖励">
      </el-table-column>
      <el-table-column header-align="center" label="操作" fixed="right" width="150px">
        <template slot-scope="scope">
          <el-button type="text">编辑</el-button>
          <el-button type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next,sizes, jumper">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList:[]
    }
  }
}
</script>

<style scope>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .teacher-cost {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.teacher-cost {
    width: 70% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/manager/components/TeacherCost.vue